import React from 'react';
import { Box, Chip } from '@mui/material';

export function MobilePillTabs({ tabs = [], value, onChange, sx }) {
  const activeRef = React.useRef(null);

  React.useEffect(() => {
    activeRef.current?.scrollIntoView({ block: 'nearest', inline: 'center' });
  }, [value]);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        overflowX: 'auto',
        mx: -1.5,
        px: 1.5,
        width: 'calc(100% + 24px)',
        boxSizing: 'border-box',
        py: 0.5,
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        ...sx,
      }}
    >
      {tabs.map((item, index) => {
        const selected = item.value === value;

        return (
          <Chip
            key={`${item.value}-${index}`}
            ref={selected ? activeRef : undefined}
            label={item.label}
            clickable
            color={selected ? 'primary' : 'default'}
            variant={selected ? 'filled' : 'outlined'}
            onClick={() => onChange(item, index)}
            sx={{
              flexShrink: 0,
              height: 36,
              px: 0.5,
              fontWeight: selected ? 700 : 500,
              bgcolor: selected ? undefined : 'background.paper',
            }}
          />
        );
      })}
    </Box>
  );
}
